<template lang="pug">
include /mixins
+b.g-row--align_center.--justify_center
  +b.g-cell--12.--6-md.--3-xl
    modal-trigger(
      v-if="isAuth"
      url='Forms/ModalWrapper'
      tag='CreateResultView'
      :id='id'
      :is_equipment="isEquipment"
      :classes='["result-create-modal"]'
    )
      template(#default='{ open }')
        +b.tt-button(@click.prevent='open')
          +e.title.P {{ _('Добавить результат') }}
    modal-trigger(
      v-else
      url='UiElements/NotPermission',
      name='NotPermission',
    )
      template(#default='{ open }')
        +b.tt-button(@click.prevent='open')
          +e.title.P {{ _('Добавить результат') }}
</template>

<script>
export default {
  props: ['id', 'isEquipment'],
  data() {
    return {
      isAuth: window.authent,
    }
  },
}
</script>
